import { createAction } from '@reduxjs/toolkit';
import * as types from './type';

const EnableAdGlareStatus = createAction(types.ENABLE_ADGLARE_STATUS);

const setEnableAdGlareStatus = enable => {
  return dispatch => {
    dispatch(EnableAdGlareStatus(enable));
  };
};

export default setEnableAdGlareStatus;
